<template>
  <div id="mybill">
    <Breadcrumb></Breadcrumb>
    <div class="common-limit line-height-40">
      <div class="form-body">
        <el-form ref="form" :model="form" label-width="80px">
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="统计方式：" prop="statRange">
                <el-radio-group v-model="statRange">
                  <el-radio :label="`date`">日期维度</el-radio
                  ><el-radio :label="`account`">账号维度</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>

            <el-col :span="8">
              <el-form-item label="日期类型：" prop="statType">
                <el-radio-group v-model="form.statType">
                  <el-radio
                    v-for="value in dictData['statType']"
                    :key="value.value"
                    :label="value.value"
                    >{{ value.label }}</el-radio
                  >
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                v-if="form.statType == '1'"
                label="统计时间："
                prop="time"
              >
                <el-date-picker
                  size="small"
                  v-model="dateTime"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item
                v-if="form.statType == '2'"
                label="统计时间："
                prop="time"
              >
                <el-date-picker
                  style="width: calc(50% - 10px) !important"
                  size="small"
                  v-model="weekBegin"
                  type="week"
                  format="yyyy 第WW周"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
                -
                <el-date-picker
                  style="width: calc(50% - 10px) !important"
                  size="small"
                  v-model="weekEnd"
                  type="week"
                  format="yyyy 第WW周"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item
                v-if="form.statType == '3'"
                label="统计时间："
                prop="time"
              >
                <el-date-picker
                  style="width: calc(50% - 10px) !important"
                  size="small"
                  v-model="monthBegin"
                  type="month"
                  format="yyyy 第M月"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
                -
                <el-date-picker
                  style="width: calc(50% - 10px) !important"
                  size="small"
                  v-model="monthEnd"
                  type="month"
                  format="yyyy 第M月"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item
                v-if="form.statType == '5'"
                label="统计时间："
                prop="time"
              >
                <el-date-picker
                  style="width: calc(50% - 10px) !important"
                  size="small"
                  v-model="yearBegin"
                  type="year"
                  format="yyyy"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
                -
                <el-date-picker
                  style="width: calc(50% - 10px) !important"
                  size="small"
                  v-model="yearEnd"
                  type="year"
                  format="yyyy"
                  value-format="yyyy-MM-dd"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="8">
              <el-form-item label="主账号：" prop="pOperNo">
                <el-input size="small" v-model="form.pOperNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item style="text-align: right" label="" prop="fundType">
                <el-button type="primary" size="small" @click="loadData"
                  >搜索</el-button
                >
                <el-button size="small" @click="resetForm">重置</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <div class="form-body">
      <div style="overflow: hidden">
        <span style="float: left">
          <el-button
            v-if="false"
            type="primary"
            size="small"
            @click="handleExport"
            >导出</el-button
          >
        </span>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="form.pageNum"
          :limit.sync="form.pageSize"
          @pagination="loadData"
          :layout="'slot, total, sizes, prev, pager, next, jumper'"
        >
        </pagination>
      </div>
      <el-table border :data="tableData">
        <el-table-column align="center" label="序号" prop="statDate" width="69">
          <template slot-scope="scope"
            ><span v-if="scope.$index != tableData.length - 1">
              {{ scope.$index + 1 }}
            </span></template
          >
        </el-table-column>
        <el-table-column
          v-if="form.statRange == 'date'"
          align="center"
          label="日期"
          prop="statDate"
        >
        </el-table-column>
        <el-table-column
          v-if="form.statRange == 'account'"
          align="center"
          label="主账号"
          prop="pOperNo"
        >
        </el-table-column>
        <el-table-column align="center" label="充值金额" prop="rechargeNum">
        </el-table-column>
        <el-table-column align="center" label="提现金额" prop="withdrawNum">
        </el-table-column>
        <el-table-column align="center" label="商家余额" prop="balanceNum">
        </el-table-column>
        <el-table-column align="center" label="支付订单量" prop="payOrderNum">
        </el-table-column>
        <el-table-column align="center" label="支付总额" prop="payTotalNum">
        </el-table-column>
        <el-table-column align="center" label="支付产品金额" prop="payProNum">
        </el-table-column>
        <el-table-column align="center" label="支付运费金额" prop="payFareNum">
        </el-table-column>
        <el-table-column align="center" label="销售金额" prop="saleTotalNum">
        </el-table-column>
        <el-table-column align="center" label="退货订单量" prop="refundOrderNum">
        </el-table-column>
        <el-table-column align="center" label="退款总额" prop="refundTotalNum">
        </el-table-column>
        <el-table-column align="center" label="退款产品金额" prop="refundProNum">
        </el-table-column>
        <el-table-column align="center" label="退款运费金额" prop="refundFareNum">
        </el-table-column>
      </el-table>
      <pagination
        class="bottom-sticky"
        v-show="total > 0"
        :total="total"
        :page.sync="form.pageNum"
        :limit.sync="form.pageSize"
        @pagination="loadData"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Breadcrumb from "@/components/common/Breadcrumb"
import { selectFundListByDate, selectFundListByAcount } from "@/api/order/stats"
import { downLoadExcel } from "@/utils/zipdownload"
import qs from "qs"
import { getShopList } from "@/api/system/shopManage"
import { listMainChild } from "@/api/system/user"

export default {
  name: "Notice",
  components: {
    Breadcrumb,
  },
  data() {
    return {
      // 查询参数
      form: {
        pageNum: 1,
        pageSize: 30,
        pOperNo: "",
        beginTime: undefined,
        endTime: undefined,
        statType: "1",
        statRange: "date",
      },
      dateTime: [],
      weekBegin: "",
      weekEnd: "",
      monthBegin: "",
      monthEnd: "",
      yearBegin: "",
      yearEnd: "",
      loading: false,
      total: 0,
      tableData: [],
      isExpand: false,
      shopName: "",
      isCheckShop: true,
      shopList: [],
      shopListClone: [],
      userList: [],

      isExpandUser: false,
      nickName: "",
      isCheckUser: true,
      designVisible: false,
      currentRow: {},
      detailData: [],
      statRange: "date",
    }
  },
  computed: {
    ...mapGetters(["dictData", "dictMap", "user"]),
  },
  created() {
    let curDate = new Date()
    let preDate = new Date(curDate.getTime() - 24 * 60 * 60 * 1000 * 7)

    this.dateTime = [
      this.parseTime(preDate, "{y}-{m}-{d}"),
      this.parseTime(curDate, "{y}-{m}-{d}"),
    ]
    this.weekBegin = this.parseTime(curDate, "{y}-{m}-{d}")
    this.weekEnd = this.parseTime(curDate, "{y}-{m}-{d}")
    this.monthBegin = this.parseTime(curDate, "{y}-{m}-{d}")
    this.monthEnd = this.parseTime(curDate, "{y}-{m}-{d}")
    this.loadData()
    this.getShops()
    this.getUserList()
  },
  methods: {
    loadData() {
      this.startLoading()

      if (this.dateTime && this.form.statType == "1") {
        this.form.beginTime = this.dateTime[0]
        this.form.endTime = this.dateTime[1]
      } else {
        this.form.beginTime = undefined
        this.form.endTime = undefined
      }

      if (this.form.statType == "2") {
        if (!this.weekBegin || !this.weekEnd) {
          this.msgError("请输入统计时间")
          this.endLoading()
          return
        }
        this.form.beginTime = this.getCurrentWeekFirstDay(
          new Date(this.weekBegin)
        )
        this.form.endTime = this.getCurrentWeekLastDay(new Date(this.weekEnd))
      }
      if (this.form.statType == "3") {
        if (!this.monthBegin || !this.monthEnd) {
          this.msgError("请输入统计时间")
          this.endLoading()
          return
        }
        this.form.beginTime = this.getCurrentMonthFirstDay(
          new Date(this.monthBegin)
        )
        this.form.endTime = this.getCurrentMonthLastDay(new Date(this.monthEnd))
      }

      if (!(this.form.beginTime && this.form.endTime)) {
        this.form.beginTime = undefined
        this.form.endTime = undefined
        this.msgError("请输入统计时间")
        this.endLoading()
        return
      }

      this.form.statRange = this.statRange
      let params = Object.assign({}, this.form)
      let loadMethod =
        params.statRange == "date"
          ? selectFundListByDate
          : selectFundListByAcount
      loadMethod(params)
        .then((response) => {
          if (response.rows.length > 0) {
            response.rows[response.rows.length - 1].statDate = "合计"
            response.rows[response.rows.length - 1].pOperNo = "合计"
          }
          this.tableData = response.rows
          this.total = response.total
          this.endLoading()
        })
        .catch(() => {
          this.endLoading()
        })
    },
    handleChangeOper() {
      let shopList = this._.clone(this.shopListClone)
      this.shopList = shopList.filter((shop) => {
        if (this.form.operNo.includes(this.user.name)) {
          return true
        }
        for (let record of this.userList) {
          if (this.form.operNo.includes(record.userName)) {
            if (record.shops) {
              for (let item of record.shops) {
                if (item.shopId == shop.shopId) {
                  return true
                }
              }
            }
          }
        }
        return false
      })
      this.form.shopId = []
      if (this.form.operNo.length == 0 && this.isCheckUser) {
        this.shopList = this._.clone(this.shopListClone)
      }
    },
    getUserList() {
      listMainChild({}).then((res) => {
        this.userList = res.rows
      })
    },
    async handleShowDetail(row) {
      let loadMethod =
        this.form.statRange == "date"
          ? selectStatShopDetail
          : selectStatDateDetail
      this.currentRow = row

      let params = Object.assign({}, this.form)
      if (this.dateTime.length > 0) {
        params.beginTime = this.dateTime[0]
        params.endTime = this.dateTime[1]
      } else {
        params.beginTime = undefined
        params.endTime = undefined
      }

      params.shopId = row.shopId
      delete params["operNo"]

      let result = await loadMethod(params)
      this.detailData = result.rows
      this.designVisible = true
    },

    resetForm() {
      this.form = {
        pageNum: 1,
        pageSize: 10,
        operNo: [],
        beginTime: undefined,
        endTime: undefined,
        shopId: [],
        statType: "1",
        statRange: "date",
        productType: "",
        platNo: "",
      }
      this.dateTime = []
      this.payTimeBegin = ""
      this.payTimeEnd = ""
      this.monthBegin = ""
      this.monthEnd = ""
      this.yearBegin = ""
      this.yearEnd = ""
    },
    /**导出 */
    handleExport() {
      if (this.form.time) {
        this.form.beginTime = this.form.time[0]
        this.form.endTime = this.form.time[1]
      } else {
        this.form.beginTime = undefined
        this.form.endTime = undefined
      }
      let params = Object.assign({}, this.form)
      delete params["time"]
      delete params["pageSize"]
      delete params["pageNum"]
      downLoadExcel(
        `/money/fund/export?${qs.stringify(this.form)}&fileName=` +
          Math.random(),
        Math.random()
      )
    },
    getShops() {
      getShopList().then((res) => {
        this.shopList = res.rows
        this.shopListClone = this._.clone(res.rows)
        this.$nextTick(() => {
          this.scrollMenu = document.querySelector(".table-menu")
          this.objectHeight = this.scrollMenu.offsetTop
          window.addEventListener("scroll", this.handleScroll)
        })
        // this.handleChangeShop()
        // res.rows.map(()=>{})
      })
    },
    handleChangeShop() {
      this.form.shopId = []
      if (this.isCheckShop) {
        this.shopList.map((record) => {
          this.form.shopId.push(record.shopId)
        })
      }
    },
    handleChangeUser() {
      this.form.operNo = []
      let shopList = this._.clone(this.shopListClone)
      if (this.isCheckUser) {
        this.userList.map((record) => {
          this.form.operNo.push(record.userName)
        })
        this.shopList = shopList
      } else {
        this.shopList = []
      }
      this.form.shopId = []
    },
    /**
     * 获取本周的第一天
     * 返回格式: YYYY-mm-dd
     *    例子: 当日为: 2020-11-27
     *      返回日期为: 2020-11-23
     * */
    getCurrentWeekFirstDay(date) {
      let weekFirstDay = new Date(date - (date.getDay() - 1) * 86400000)
      let firstMonth = Number(weekFirstDay.getMonth()) + 1

      if (firstMonth < 10) {
        firstMonth = "0" + firstMonth
      }
      let weekFirstDays = weekFirstDay.getDate()
      if (weekFirstDays < 10) {
        weekFirstDays = "0" + weekFirstDays
      }
      return weekFirstDay.getFullYear() + "-" + firstMonth + "-" + weekFirstDays
    },
    /**
     * 获取本周的最后一天
     * 返回格式: YYYY-mm-dd
     *    例子: 当日为: 2020-11-27
     *      返回日期为: 2020-11-29
     * */
    getCurrentWeekLastDay(date) {
      let weekFirstDay = new Date(date - (date.getDay() - 1) * 86400000)
      let weekLastDay = new Date((weekFirstDay / 1000 + 6 * 86400) * 1000)
      let lastMonth = Number(weekLastDay.getMonth()) + 1
      if (lastMonth < 10) {
        lastMonth = "0" + lastMonth
      }
      let weekLastDays = weekLastDay.getDate()
      if (weekLastDays < 10) {
        weekLastDays = "0" + weekLastDays
      }
      return weekFirstDay.getFullYear() + "-" + lastMonth + "-" + weekLastDays
    },
    getCurrentMonthFirstDay(date) {
      date.setDate(1)
      let month = parseInt(date.getMonth() + 1)
      let day = date.getDate()
      if (month < 10) {
        month = "0" + month
      }
      if (day < 10) {
        day = "0" + day
      }
      return date.getFullYear() + "-" + month + "-" + day
    },
    getCurrentMonthLastDay(date) {
      let currentMonth = date.getMonth()
      let nextMonth = ++currentMonth
      let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1)
      let oneDay = 1000 * 60 * 60 * 24
      let lastTime = new Date(nextMonthFirstDay - oneDay)
      let month = parseInt(lastTime.getMonth() + 1)
      let day = lastTime.getDate()
      if (month < 10) {
        month = "0" + month
      }
      if (day < 10) {
        day = "0" + day
      }
      return date.getFullYear() + "-" + month + "-" + day
    },
  },
}
</script>
<style lang="scss" scoped>
.btn-bar-right {
  text-align: right;
}
</style>
